import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import useResponsive from "../../hooks/useResponsive";
import RoleTop from "./role-top";
import RoleBottom from "./role-bottom";

const RoleManagementContents = () => {
  return (
    <Box sx={{p: 3}}>
      {/* <RoleTop /> */}
      <RoleBottom />
    </Box>
  );
};

export default RoleManagementContents;

